// extracted by mini-css-extract-plugin
export default {"title":"styles_title__yH-xE","sbp-logo":"styles_sbp-logo__b5ox5"};